import CommonSelector from './src/main';

/* istanbul ignore next */
CommonSelector.install = function(Vue) {
  Vue.component(CommonSelector.name, CommonSelector);
};

export default CommonSelector;
